export default "__VITE_ASSET__ErFp8T48__"